export default {
  apiKey: "AIzaSyDHp7J-XIz5eau-0x8lyO2xlmxCHLUJUa4",
  authDomain: "arbiflex-finance.firebaseapp.com",
  databaseURL: "your_firebase_database_url",
  projectId: "arbiflex-finance",
  storageBucket: "arbiflex-finance.appspot.com",
  messagingSenderId: "949666785946"
};
